import { PageFormat } from '@hashnode/database-schema'
import fs from 'fs'
import path from 'path'

export const VALID_EXTENSIONS = ['.mdx', '.md'] as const

export function readProjectFile(cwd: string, filePath: string) {
	const file = path.join(cwd, filePath)

	return fs.readFileSync(file, 'utf-8')
}

export function readFile(filePath: string) {
	return fs.readFileSync(filePath, 'utf-8')
}

export function isFileType(filePath: string) {
	// Get the file extension
	const fileExtension = path.extname(filePath)

	// Convert to lower case for case-insensitive comparison
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	return VALID_EXTENSIONS.includes(fileExtension.toLowerCase() as any)
}

/**
 * Gets all .mdx files in a directory and its subdirectories relative to the version folder (baseDir)
 */
export function getAllMdxFilePaths(
	dir: string,
	baseDir: string = dir,
	absolutePaths = false,
): string[] {
	const files = fs.readdirSync(dir)
	let mdxFiles: string[] = []

	for (const file of files) {
		const filePath = path.join(dir, file)
		const stats = fs.statSync(filePath)
		const relativePath = path.relative(baseDir, filePath)

		if (stats.isDirectory()) {
			// Recursively search subdirectories
			const subDirFiles = getAllMdxFilePaths(filePath, baseDir, absolutePaths)
			mdxFiles = mdxFiles.concat(subDirFiles)
		} else if (isFileType(filePath)) {
			if (absolutePaths) {
				mdxFiles.push(filePath)
			} else {
				mdxFiles.push(relativePath)
			}
		}
	}

	return mdxFiles
}

const mapFileExtensionToPageFormat: {
	[key in (typeof VALID_EXTENSIONS)[number]]: PageFormat
} = {
	'.mdx': 'MDX' as const,
	'.md': 'MD' as const,
}

export function validateFileType(filePath: string): PageFormat {
	if (!isFileType(filePath)) {
		throw new Error(`Invalid file type. Please use ${VALID_EXTENSIONS.join(', ')} as extensions.`)
	}
	return mapFileExtensionToPageFormat[path.extname(filePath)]
}
